//export const DOMAIN = "http://localhost:3000/";
export const DOMAIN = "https://api.wastenofood.org/";
export const BASE_URL = DOMAIN + "api/v1";
//export const IMAGE_PATH = DOMAIN + "uploads/";
export const IMAGE_PATH =
  "https://wnfimages.s3.us-east-2.amazonaws.com/images/";
const VOLUNTEERS_URL = BASE_URL + "/volunteers";
const DONORS_URL = BASE_URL + "/donors";
const CHARITIES_URL = BASE_URL + "/charities";
const LOCAL_ADMIN_URL = BASE_URL + "/local-admins";
const ADMIN_URL = BASE_URL + "/admins";
const PAYMENT_URL = BASE_URL + "/payment";
const REGION_URL = BASE_URL + "/regions";
const DONATION_URL = BASE_URL + "/donations";
const DASHBOARD_PATH = "/dashboard";

const API = {
  baseUrl: BASE_URL,
  login: BASE_URL + "/auth/adminLogin",
  signUp: BASE_URL + "/signup",
  setPassword: BASE_URL + "/auth/setPassword",
  resetPassword: BASE_URL + "/auth/admin-reset-password",
  updatePassword: BASE_URL + "/auth/updatePassword",
  validateResetToken: BASE_URL + "/auth/validateResetToken",
  verifyEmail: BASE_URL + "/auth/verifyEmail",
  addRegion: REGION_URL,
  updateRegion: REGION_URL,
  getAllRegions: REGION_URL,
  getAllPendingRegions: REGION_URL + "/pending/all",
  getAllDonations: DONATION_URL,
  getAllDonationsByRegion: DONATION_URL + "/region",
  searchDonation: DONATION_URL + "/search",
  searchDonationByRegion: DONATION_URL + "/search/region",
  searchDonationByStatus: DONATION_URL + "/search/status",
  searchDonationByStatusRegion: DONATION_URL + "/search/status/region",
  getDonorDashboardStatsInfo: DONORS_URL + "/dashboard/stats/",
  updateDonor: DONORS_URL,
  addDonor: DONORS_URL,
  getAllDonors: DONORS_URL,
  getDonorInfo: DONORS_URL,
  getDonorDonations: DONORS_URL + "/donations",
  getAllDonorsByRegion: DONORS_URL + "/region",
  updateDonorUser: DONORS_URL + "/users",
  addDonorUser: DONORS_URL + "/addUser",
  searchAllDonors: DONORS_URL + "/search",
  searchAllDonorsByRegion: DONORS_URL + "/search/region",
  searchAllDonorsByStatus: DONORS_URL + "/search/status",
  searchAllDonorsByStatusRegion: DONORS_URL + "/search/status/region",
  updateCharity: CHARITIES_URL,
  addCharity: CHARITIES_URL,
  getAllCharities: CHARITIES_URL,
  getCharityInfo: CHARITIES_URL,
  updateCharityUser: CHARITIES_URL + "/users",
  addCharityUser: CHARITIES_URL + "/addUser",
  getCharityDonations: CHARITIES_URL + "/donations",
  getAllCharitiesByRegion: CHARITIES_URL + "/region",
  searchCharity: CHARITIES_URL + "/search",
  searchCharityByRegion: CHARITIES_URL + "/search/region",
  searchCharityByStatus: CHARITIES_URL + "/search/status",
  searchCharityByStatusRegion: CHARITIES_URL + "/search/status/region",
  updateVolunteer: VOLUNTEERS_URL,
  addVolunteer: VOLUNTEERS_URL,
  getVolunteerInfo: VOLUNTEERS_URL,
  getAllVolunteers: VOLUNTEERS_URL,
  getVolunteerDonations: VOLUNTEERS_URL + "/donations",
  getAllVolunteersByRegion: VOLUNTEERS_URL + "/region",
  searchVolunteer: VOLUNTEERS_URL + "/search",
  searchVolunteerByRegion: VOLUNTEERS_URL + "/search/region",
  searchVolunteerByStatus: VOLUNTEERS_URL + "/search/status",
  searchVolunteerByStatusRegion: VOLUNTEERS_URL + "/search/status/region",
  updatePayment: PAYMENT_URL,
  addPayment: PAYMENT_URL,
  getAllPayments: PAYMENT_URL,
  updateLocalAdmin: LOCAL_ADMIN_URL,
  addLocalAdmin: LOCAL_ADMIN_URL,
  getLocalAdminInfo: LOCAL_ADMIN_URL,
  getAllLocalAdmins: LOCAL_ADMIN_URL,
  addLocalAdminUser: LOCAL_ADMIN_URL + "/users",
  getAllLocalAdminUsers: LOCAL_ADMIN_URL + "/users/all",
  updateLocalAdminUser: LOCAL_ADMIN_URL + "/users",
  searchLocalAdmin: LOCAL_ADMIN_URL + "/search",
  searchLocalAdminByStatus: LOCAL_ADMIN_URL + "/search/status",
  getDashboardUsersByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/users",
  getDashboardInfoByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/donations",
  getTopDonorsByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/top/donors",
  getTopCharitiesByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/top/charities",
  getTopVolunteersByRegion:
    LOCAL_ADMIN_URL + DASHBOARD_PATH + "/top/volunteers",
  getAllDonationsDetailsByRegion:
    LOCAL_ADMIN_URL + DASHBOARD_PATH + "/donations/all",
  getAllMealsDetailsByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/meals/all",
  getTopLocationsByRegion: LOCAL_ADMIN_URL + DASHBOARD_PATH + "/top/locations",
  getAllDonationStatusByRegion:
    LOCAL_ADMIN_URL + DASHBOARD_PATH + "/donations/status",
  getAllAdmins: ADMIN_URL,
  addAdminUser: ADMIN_URL,
  updateAdminUser: ADMIN_URL,
  getAllAdminUsers: ADMIN_URL + "/all",
  getAdminDashboardUsers: ADMIN_URL + DASHBOARD_PATH + "/users",
  getAdminDashboardInfo: ADMIN_URL + DASHBOARD_PATH + "/donations",
  getTopDonors: ADMIN_URL + DASHBOARD_PATH + "/top/donors",
  getTopCharities: ADMIN_URL + DASHBOARD_PATH + "/top/charities",
  getTopVolunteers: ADMIN_URL + DASHBOARD_PATH + "/top/volunteers",
  getTopRegions: ADMIN_URL + DASHBOARD_PATH + "/top/regions",
  getTopLocations: ADMIN_URL + DASHBOARD_PATH + "/top/locations",
  getAllDonationsDetails: ADMIN_URL + DASHBOARD_PATH + "/donations/all",
  getAllMealsDetails: ADMIN_URL + DASHBOARD_PATH + "/meals/all",
  getAllDonationStatus: ADMIN_URL + DASHBOARD_PATH + "/donations/status",
  UploadUrl: BASE_URL + "/upload",
  updateAdminPassword: ADMIN_URL + "/updatePassword",
  updateLocalAdminPassword: LOCAL_ADMIN_URL + "/updatePassword",
  getDonorDashboardInfo: DONORS_URL + DASHBOARD_PATH,
  getCharityDashboardInfo: CHARITIES_URL + DASHBOARD_PATH,
  getVolunteerDashboardInfo: VOLUNTEERS_URL + DASHBOARD_PATH,
  getDonationInfo: DONATION_URL,
  updateDonationInfo: DONATION_URL + "/info",
  getDonationInfoByCharityId: DONATION_URL + "/charity",
};

export { API };
